import { defineComponent as _defineComponent } from 'vue'
import {
  useEprintActions,
  useEprintSession
} from '@/composables/format-edit/useEprintSession'


export default /*#__PURE__*/_defineComponent({
  __name: 'EprintPaypayNoticeDialog',
  setup(__props) {

const session = useEprintSession()
const actions = useEprintActions()

return { __sfc: true,session, actions }
}

})